import React, {useEffect, useRef} from 'react';
import Grid from "@material-ui/core/Grid";
import BreadCrumb from "../../components/BreadCrumb";


import {Link, withRouter} from 'react-router-dom';
import Button from "@material-ui/core/Button";
import AddIcon from '@material-ui/icons/Add';
import Box from "@material-ui/core/Box";
import useStyles from "../../styles";
import {useDispatch, useSelector} from "react-redux";
import EnhancedTable from "../../components/EnhancedTable";
import SiteWrapper from "../../SiteWrapper";
import {deleteMachineAction, getMachinesAction} from "../../store/actions/MachineAction";
import StatusComponent from "../../components/StatusComponent";
import {utils} from '../../helper/Utils'
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import MenuActionComponent from "../../components/MenuActionComponent";


const VehiclesPage = (props) => {

    const classes = useStyles();

    const dispatch = useDispatch();
    const vehicles = useSelector(state => state.machine.machines);
    const count = useSelector(state => state.machine.count);

    const fetchIdRef = useRef(0);

    const fetchData = React.useCallback((pager, query) => {

        let search = Object.assign({}, {limit: pager.pageSize, offset: pager.pageIndex * pager.pageSize}, query);

        const fetchId = ++fetchIdRef.current;

        if (fetchId === fetchIdRef.current) {
            dispatch(getMachinesAction(search));
        }

    }, [dispatch]);


    useEffect(() => {
        fetchData({pageIndex: utils.DEFAULT_PAGE_INDEX, pageSize: utils.DEFAULT_PAGE_SIZE});
    }, [fetchData]);


    const columns = [
        {
            Header: "Name",
            accessor: d => (d.nickname ?? '-')
        },

        {
            Header: "Reg No",
            accessor: "reg_no"
        },
        {
            Header: "Type",
            accessor: "type.name"
        },
        {
            Header: "Model",
            accessor: "model.name"
        },
        {
            Header: "Make",
            accessor: d => (d.make ?? '-')
        },
        {
            Header: "Fuel/km",
            accessor: d => (d.fuel_km ? utils.numberFormatter(d.fuel_km): '-')
        },
        {
            Header: "Status",
            accessor: d => <StatusComponent status={d.status}/>
        },
        {
            Header: 'Action',
            Cell: row => (<MenuActionComponent item={{id: row.row.original.id, showView: false}} url={"vehicles"}
                                           deleteAction={deleteMachineAction}/>)
        }
    ];

    return (
        <>
            <SiteWrapper>
                <BreadCrumb crumbs={[{
                    'name': 'Trucks',
                    'link' : '#'
                }]}/>
                <Grid container >

                    <Grid container className={classes.marginTop}>
                        <Grid item xs={12} sm={4}>
                            <Box>
                                <Typography className={clsx(classes.medium, classes.pageTitle)}>
                                    Trucks
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid container item xs={12} sm={8} justify="flex-end">
                            <Box>
                                <Button className={classes.actionButton} startIcon={<AddIcon/>}>
                                    <Link to="/vehicles/create" className={classes.unstyledLink}>New Truck</Link>
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Recent Deposits */}
                    <Grid item xs={12} md={12} lg={12}>
                            {vehicles && <EnhancedTable
                                columns={columns}
                                data={vehicles}
                                fetchData={fetchData}
                                pageCount={count && count}
                            />}
                    </Grid>
                </Grid>
            </SiteWrapper>
        </>
    );
};

export default withRouter(VehiclesPage);